(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["pv-beskrivelse"] && !Shopify.designMode) return;
  try {
    (function () {
    function apne() {
      if (!window.matchMedia('(min-width: 750px)').matches) return;
      document.querySelectorAll('.pv-trekk__rad[data-apen-desktop]').forEach(function (d) { d.open = true; d.removeAttribute('data-apen-desktop'); });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apne); else apne();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["pv-levering"] && !Shopify.designMode) return;
  try {
    if (!window.__pvOppdater) {
    window.__pvOppdater = true;
    document.addEventListener('variant:update', function (e) {
      var html = e.detail && e.detail.data && e.detail.data.html;
      if (!html || !html.getElementById) return;
      document.querySelectorAll('[data-pv-oppdater]').forEach(function (el) {
        var n = html.getElementById(el.id);
        if (n) { el.innerHTML = n.innerHTML; el.className = n.className; }
      });
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["pv-meta"] && !Shopify.designMode) return;
  try {
    if (!window.__pvOppdater) {
    window.__pvOppdater = true;
    document.addEventListener('variant:update', function (e) {
      var html = e.detail && e.detail.data && e.detail.data.html;
      if (!html || !html.getElementById) return;
      document.querySelectorAll('[data-pv-oppdater]').forEach(function (el) {
        var n = html.getElementById(el.id);
        if (n) el.innerHTML = n.innerHTML;
        if (n) el.className = n.className;
      });
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["pv-passer-til"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pv-passer-til')) {
    customElements.define('pv-passer-til', class extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', (e) => {
          const btn = e.target.closest('.pv-passer__knapp');
          if (btn) this.add(btn);
        });
      }
      async add(btn) {
        const tekst = btn.innerHTML;
        btn.setAttribute('aria-busy', 'true');
        try {
          const sections = Array.from(document.querySelectorAll('cart-items-component'))
            .map((el) => el.dataset.sectionId).filter(Boolean);
          const body = { items: [{ id: Number(btn.dataset.variantId), quantity: 1 }] };
          if (sections.length) body.sections = sections.join(',');
          const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
          const res = await fetch(root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify(body),
          });
          const data = await res.json();
          if (!res.ok || data.status) throw new Error(data.description || data.message || 'Feil');
          const cart = await (await fetch(root + 'cart.js')).json();
          try {
            const { CartAddEvent } = await import('@theme/events');
            btn.dispatchEvent(new CartAddEvent(cart, String(btn.dataset.variantId), {
              source: 'pv-passer-til', itemCount: 1, productId: btn.dataset.productId, sections: data.sections,
            }));
          } catch (err) {
            document.querySelectorAll('.cart-count, [data-cart-count]').forEach((el) => { el.textContent = cart.item_count; });
          }
          btn.innerHTML = '<span class="pv-passer__pluss" aria-hidden="true">✓</span><span class="pv-passer__ktekst">Lagt til</span>';
        } catch (err) {
          console.error(err);
          btn.innerHTML = '<span class="pv-passer__pluss" aria-hidden="true">!</span><span class="pv-passer__ktekst">Kunne ikke legge til</span>';
        }
        btn.removeAttribute('aria-busy');
        setTimeout(() => { btn.innerHTML = tekst; }, 2500);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
